import { FC } from "react";

import { CopayInformationProps } from "./types";




const CopayInformation: FC<CopayInformationProps> = ({ copay_information }): JSX.Element => {
  return (
    <div className="card">
      <div className="card-header zilretta-theme">
        <h4 className="m-0">{"CoPay Program Eligibility"}</h4>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Eligible:</label>
              </div>
              <div className="col-6">
                <p>
                  {copay_information && copay_information.eligibility ? "Eligible" : "N/A"}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Enrolled in Program:</label>
              </div>
              <div className="col-6">
                <p>
                  {copay_information && copay_information.enrolled ? "Yes" : "No"}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Claim Status:</label>
              </div>
              <div className="col-6">
                <p>
                  {copay_information ? copay_information.status : "N/A"}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Member ID:</label>
              </div>
              <div className="col-6">
                <p>
                  {copay_information ? copay_information.member_id : "N/A"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopayInformation;
